import { render, staticRenderFns } from "./ListaPrenotazioni.vue?vue&type=template&id=3a20c938&scoped=true"
import script from "./ListaPrenotazioni.vue?vue&type=script&lang=js"
export * from "./ListaPrenotazioni.vue?vue&type=script&lang=js"
import style0 from "./ListaPrenotazioni.vue?vue&type=style&index=0&id=3a20c938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20c938",
  null
  
)

export default component.exports